export const env = {
    apiDomain: "https://api.selectnpay.com/"
}
